import React, { FC } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

import RichTextLabel from '@/components/RichTextLabel/RichTextLabel';
import { borders } from '@/theme/constants';
import typography from '@/theme/typography';

interface MessageCardProps {
  icon: React.ReactNode;
  title: string;
  content: string;
  onClick?: () => void;
}

const MessageCard: FC<MessageCardProps> = ({ icon, title, content, onClick }) => {
  const theme = useTheme();
  const { spacing } = theme;

  return (
    <Box
      onClick={onClick}
      sx={{
        overflow: 'hidden',
        bgcolor: 'background.default',
        borderRadius: spacing(0.5),
        cursor: 'pointer',
        border: borders.default,
        borderColor: 'grey.400',
        '&:hover': {
          borderColor: 'primary.main'
        }
      }}
    >
      <Stack>
        <Box
          sx={{
            height: spacing(5),
            padding: spacing(1, 2),
            display: 'flex',
            alignItems: 'center',
            gap: spacing(2),
            bgcolor: 'grey.100'
          }}
        >
          <Box
            sx={{
              width: spacing(3),
              height: spacing(3),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            {icon}
          </Box>
          <Typography
            variant="body1"
            sx={{
              fontWeight: typography.fontWeightMedium,
              color: 'text.primary',
              flex: 1,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'start'
            }}
            title={title}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            height: 96,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            m: 2,
            textOverflow: 'ellipsis'
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              lineHeight: 1.5,
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: '4',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textAlign: 'start'
            }}
          >
            <RichTextLabel html={content} />
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default MessageCard;
